import { addEnhancedAttributionMacroValue } from './attributionMacro';
import { teadsApi } from './teads-api';

let ClickThruMacros = new Map();

export function setupClickthruMacros() {
  teadsApi.getContextData((e, ctx) => {
    if (e) {
      return console.error(e);
    }
    const tracking = Object.entries<string>(ctx?.tracking ?? {});
    const gdpr = Object.entries<string>(ctx?.gdpr ?? {})
      .map(([key, value]): [string, string] => {
        switch (key) {
          case 'applies':
            return ['gdpr', value];
          case 'consent':
            return ['gdpr_consent', value];
          default:
            throw new Error('Unknown Key');
        }
      })
      .filter((v) => typeof v !== 'undefined');

    ClickThruMacros = new Map([...tracking, ...gdpr]);
  });
}

const GenericMacroRegex = '(?:\\[([^\\]]+)])|(?:\\${([^}]+)})|(?:%5B(.+?)%5D)|(?:%24%7B(.+?)%7D)';
const GDPRMacroRegex = '(?:\\[(GDPR)])|(?:\\${(GDPR)})|(?:%5B(GDPR)%5D)|(?:%24%7B(GDPR)%7D)';
const GDPRConsentMacroRegex =
  '(?:\\[(GDPR_CONSENT)(?:_\\d+)])|(?:\\${(GDPR_CONSENT)(?:_\\d+)})|(?:%5B(GDPR_CONSENT)(?:_\\d+)%5D)|(?:%24%7B(GDPR_CONSENT)(?:_\\d+)%7D)';

const MacroRegexContent = [GDPRConsentMacroRegex, GDPRMacroRegex, GenericMacroRegex].join('|');
const MacroRegex = new RegExp(`(${MacroRegexContent})`, 'gi');

export function replaceClickthruMacros(link: string) {
  return link.replace(MacroRegex, (...args: string[]) => {
    const [, macro, ...other] = args;
    const [, , ...maybeMacroName] = other.reverse();
    const macroName = maybeMacroName.find((v) => !!v)?.toLowerCase() ?? '';

    if (macroName === 'timestamp') return Date.now().toString();

    return ClickThruMacros.has(macroName) ? encodeURIComponent(ClickThruMacros.get(macroName).toString()) : macro;
  });
}

export function addEnhancedAttributionMacro(destination_url: string): string {
  return addEnhancedAttributionMacroValue(destination_url, ClickThruMacros.get('auctid'));
}
